import React, { useCallback, useEffect } from 'react';
import { FormControl, Select, useColorMode } from '@chakra-ui/react';
import { useCalendarSettings, useFilters } from '../../../../lib/context';

interface ISelectFilterComponentProps {
	label: string;
	options: string[];
	selectedOptions: string[];
	filterKey: string;
	color?: string;
	disabled?: boolean;
}

export const SelectFilterComponent: React.FC<ISelectFilterComponentProps> = ({
	color,
	label,
	options,
	selectedOptions,
	filterKey,
	disabled = false,
}) => {
	const { setFilters } = useFilters();
	const { colorMode } = useColorMode();
	const { settings } = useCalendarSettings();

	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLSelectElement>) => {
			const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value).filter(
				(value) => value !== ''
			);
			setFilters((prev) => ({
				...prev,
				[filterKey]: selectedValues,
			}));
		},
		[filterKey, setFilters]
	);

	useEffect(() => {
		if (options.length === 0) {
			setFilters((prev) => ({
				...prev,
				[filterKey]: [],
			}));
		}
	}, [options, filterKey, setFilters]);

	const { calendarBordersColor } = settings.styles[colorMode];
	return (
		<FormControl>
			<Select
				size='sm'
				placeholder={`Select ${label.toLowerCase()}`}
				value={selectedOptions}
				onChange={handleChange}
				borderRadius='xs'
				color={color}
				iconColor='black'
				disabled={disabled}
				sx={{
					'::placeholder': {
						color: color,
					},
				}}
				borderColor={calendarBordersColor}
			>
				{options.map((option) => (
					<option key={option} value={option} style={{ color }}>
						{option}
					</option>
				))}
			</Select>
		</FormControl>
	);
};
